<template>
  <ul class="navigation" :class="direction === 'row' && 'navigation--row'">
    <li class="navigation__item pt-0" v-if="allow_dc_login && !is_authenticated()">
      <router-link :to="{ name: 'dc-sso' }" class="navigation__link">
        <vb-icon class="navigation__icon" :name="'ticket'" :color="sass('primary')" :size="15" />
        <span class="text-primary semibold">Ho un buono</span>
      </router-link>
    </li>
    <li class="navigation__item">
      <router-link :to="{ hash: 'site-prefooter' }" class="navigation__link">
        <vb-icon class="navigation__icon" :name="'interrogation'" :color="sass('gray-600')" :size="15" />
        <span>Assistenza</span>
      </router-link>
    </li>
    <li class="navigation__item" v-if="is_authenticated()">
      <router-link @click.native="logout()" :to="{ name: 'homepage' }" class="navigation__link">
        <vb-icon class="navigation__icon" :name="'login'" :color="sass('gray-600')" :size="15" />
        <span>Esci</span>
      </router-link>
    </li>
  </ul>
</template>

<script>
import { get_config } from "@src/utilities"
import { service_handler } from "@src/services"


export default {
  name: 'navigation',

  components: {
  },

  props: {
    direction: String,
  },

  data() {
    return {
    }
  },

  computed: {

    allow_dc_login: () => get_config('guiSettings.allowDcLogin'),
  },

  created() {
  },

  mounted() {
  },

  methods: {

    logout(){
      service_handler(
        'logout'
      )
      .then(
        (success) => {
          this.log('[logout] - success')
          this.log(success.data)
        },
        (error) => {
          this.log('[logout] - error')
          this.log(error.response)
        }
      )
    }
  },
}
</script>

<style lang="scss" scoped>

  .navigation {
    $this: &;
    margin: 0;
    padding: 0;

    &--row {
      display: flex;
      align-items: center;
    }

    &__item {
      list-style: none;
      border-bottom: 1px solid $gray-200;
      padding: $grid-gutter-width / 3 0;
      line-height: normal;

      @at-root #{$this}--row & {
        border: none;
        padding: 0 $grid-gutter-width / 3;
      }

      &:last-child{
        padding-bottom: 0;
        border-bottom: none;
      }
    }

    &__link {
      display: flex;
      align-items: center;
      color: $body-color !important;
      line-height: normal;

      &:hover {
        color: $link-color !important;
      }
    }

    &__icon {
      margin-right: $grid-gutter-width / 5;
    }
  }

</style>